import { FileBarChart2, FileSpreadsheet, FileText, FileType } from "lucide-react";
import { API } from "@/lib/api";
import { toast } from "sonner";

const DATASETS = [
  { id: "invoices", label: "Faturas / Cobranças" },
  { id: "partners", label: "Rede Credenciada" },
  { id: "atendimentos", label: "Atendimentos" },
  { id: "companies", label: "Empresas B2B" },
  { id: "leads", label: "Leads de vendas" },
];
const FORMATS = [
  { id: "xlsx", label: "Excel (XLSX)", icon: FileSpreadsheet, color: "#10B981" },
  { id: "pdf", label: "PDF", icon: FileText, color: "#EF4444" },
  { id: "csv", label: "CSV", icon: FileType, color: "#0EA5E9" },
];

async function downloadReport(kind, dataset) {
  const token = localStorage.getItem("solimoes_token");
  try {
    const res = await fetch(`${API}/reports/${kind}?dataset=${dataset}`, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error("Erro");
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${dataset}.${kind}`; a.click();
    window.URL.revokeObjectURL(url);
    toast.success(`Relatório ${kind.toUpperCase()} gerado!`);
  } catch {
    toast.error("Erro ao gerar relatório");
  }
}

export default function GestorRelatorios() {
  return (
    <div className="space-y-6" data-testid="gestor-relatorios-page">
      <div>
        <h1 className="font-display text-3xl font-black text-[#0E2A5C] flex items-center gap-2"><FileBarChart2 className="h-7 w-7" /> Relatórios</h1>
        <p className="text-sm text-slate-500">Exporte dados em Excel, PDF ou CSV</p>
      </div>

      <div className="space-y-4">
        {DATASETS.map(ds => (
          <div key={ds.id} className="card-soft p-6 flex flex-wrap items-center justify-between gap-4" data-testid={`dataset-${ds.id}`}>
            <div>
              <div className="font-display text-lg font-bold text-[#0E2A5C]">{ds.label}</div>
              <div className="text-sm text-slate-500">Dataset: {ds.id}</div>
            </div>
            <div className="flex flex-wrap gap-2">
              {FORMATS.map(f => (
                <button key={f.id} onClick={()=>downloadReport(f.id, ds.id)} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-slate-200 hover:border-[#2A8FE0] hover:text-[#2A8FE0] text-sm font-semibold transition" data-testid={`export-${ds.id}-${f.id}`}>
                  <f.icon className="h-4 w-4" style={{color: f.color}} /> {f.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
